import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.index-of.js";
var _excluded = ["groupType"];
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/utils.ts";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import { isNotEmpty, isNumber } from '@gmini/utils';
import { isBimNode, isUserClassifierNode, isUserClassifierGroupNode, isAssemblyClassifierNode } from "../../classifier-service/Node";
import { isNodeType } from "../../classifier-service/adapters";
import { getNode } from "../../classifier-service";
import { isPopulatedType } from "./types";
export function pathEquals(a, b) {
  return a.length === b.length && a.join() === b.join();
}
export function getParentsByPath(nodes, path) {
  return path.slice(0, path.length - 1).map(function (key) {
    return getNode(nodes, getRefFromPathKey(key));
  }).filter(isNotEmpty);
}
export function findFlatNodesByKey(key, tree) {
  return tree.filter(function (flatNode) {
    return flatNode.path[flatNode.path.length - 1] === key;
  });
}
export function findFlatNodeByKey(key, tree) {
  return tree.find(function (flatNode) {
    return flatNode.path[flatNode.path.length - 1] === key;
  });
}
export function findInFlatTree(tree, path) {
  return tree.find(function (item) {
    return pathEquals(item.path, path);
  }) || null;
}
export function findNeighbours(tree, path) {
  return tree.filter(function (item) {
    return pathEquals(item.path.slice(0, -1), path.slice(0, -1));
  });
}
export function findNextItemIndex(tree, path) {
  var neighbours = findNeighbours(tree, path);
  var itemIdxNeighbours = neighbours.findIndex(function (item) {
    return pathEquals(item.path, path);
  });
  var nextItem = neighbours[itemIdxNeighbours + 1];

  if (!nextItem) {
    return -1;
  }

  return tree.findIndex(function (item) {
    return pathEquals(item.path, nextItem.path);
  });
}
export function findPrevItemIndex(tree, path) {
  var neighbours = findNeighbours(tree, path);
  var itemIdxNeighbours = neighbours.findIndex(function (item) {
    return pathEquals(item.path, path);
  });

  if (itemIdxNeighbours < 0) {
    return -1;
  }

  var nextItem = neighbours[itemIdxNeighbours - 1];

  if (!nextItem) {
    return -1;
  }

  return tree.findIndex(function (item) {
    return pathEquals(item.path, nextItem.path);
  });
}
export function findFlatChildren(tree, parentPath) {
  var result = [];
  var parentLevel = parentPath.length;
  var startIdx = tree.findIndex(function (item) {
    return pathEquals(item.path, parentPath);
  });

  if (startIdx < 0) {
    return result;
  }

  for (var i = startIdx + 1; i < tree.length; i++) {
    var item = tree[i];
    var itemLevel = item.path.length;

    if (itemLevel <= parentLevel) {
      break;
    }

    result.push(item);
  }

  return result;
}
export function findFlatParents(tree, path) {
  var result = [];
  var endIdx = tree.findIndex(function (item) {
    return pathEquals(item.path, path);
  });
  var startIdx = tree.findIndex(function (item) {
    return pathEquals(item.path, [path[0]]);
  });

  if (startIdx < 0 || endIdx < 0) {
    return result;
  }

  var lastLevel = path.length;

  for (var i = endIdx; i >= startIdx; i--) {
    var item = tree[i];
    var level = item.path.length;

    if (level >= lastLevel) {
      continue;
    }

    result.push(item);
    lastLevel = level;
  }

  return result;
}
export function getKeyByPath(path) {
  return path[path.length - 1];
}
export function sliceTreeOverKeys(tree, key, secondKey) {
  var startIdx = tree.findIndex(function (item) {
    return buildKeyByPath(item.path) === key;
  });
  var endIdx = tree.findIndex(function (item) {
    return buildKeyByPath(item.path) === secondKey;
  }); //reverse

  if (startIdx > endIdx) {
    return tree.slice(0, endIdx);
  }

  return tree.slice(endIdx, tree.length - 1);
}
export function sliceTreeByKeys(tree, key, secondKey) {
  var startIdx = tree.findIndex(function (item) {
    return buildKeyByPath(item.path) === key;
  });
  var endIdx = tree.findIndex(function (item) {
    return buildKeyByPath(item.path) === secondKey;
  }); //reverseSelect

  if (startIdx > endIdx) {
    var _item = tree[startIdx];
    return tree.slice(endIdx, startIdx).reverse().filter(function (treeItem) {
      return !_item.path.includes(treeItem.path[treeItem.path.length - 1]);
    });
  }

  var item = tree[endIdx];
  return tree.slice(startIdx, endIdx).filter(function (treeItem) {
    return !item.path.includes(treeItem.path[treeItem.path.length - 1]);
  });
}
export function findInFlatTreeByIdx(tree, index) {
  return tree[index] || null;
}
export function getFlatTreeParentItems(nodePath, flatTree) {
  var nodes = [];

  var findParent = function findParent(nodePath) {
    flatTree.forEach(function (item, index) {
      return pathEquals(item.path, nodePath) ? nodes.unshift({
        item: item,
        index: index
      }) : null;
    });

    if (nodePath.length) {
      findParent(nodePath.slice(0, -1));
    }

    return nodes;
  };

  return findParent(nodePath.slice(0, -1));
}
export function getOnlyParents(tree, item, arr) {
  return findFlatParents(tree, item.path).some(function (parent) {
    return arr.some(function (selectedItem) {
      return getKeyByPath(selectedItem.path) === getKeyByPath(parent.path);
    });
  }) ? null : item;
}
export function getRefFromPathKey(key) {
  var _key$split = key.split('_'),
      _key$split2 = _slicedToArray(_key$split, 2),
      type = _key$split2[0],
      id = _key$split2[1];

  var ref = {
    type: type,
    id: Number(id)
  }; //TODO типизация, сюда может прийти любой тип иза дерева

  if ( // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (isNodeType(ref.type) || isPopulatedType(ref.type)) && isNumber(ref.id)) {
    return ref;
  }

  throw new Error("[parseTreeItemKey]: Could not parse key: ".concat(key, ", ref type: ").concat(ref.type, ", ref id: ").concat(ref.id, " "));
}
export function populateReference(nodes, r) {
  var element = getNode(nodes, r.element);
  return _objectSpread(_objectSpread({}, r), {}, {
    type: 'ReferenceNode',
    element: element
  });
}
export function populateDynamicReference(nodes, r) {
  var element = getNode(nodes, r.element);
  return _objectSpread(_objectSpread({}, r), {}, {
    type: 'DynamicReferenceNode',
    element: element
  });
}
export function createGeneralGroupNode(g) {
  var groupType;

  switch (g.type) {
    case 'UserClassifierEmptyGroupNode':
      groupType = 'Empty';
      break;

    case 'UserClassifierGroupWithGroupsNode':
      groupType = 'WithGroups';
      break;

    case 'UserClassifierGroupWithElementsNode':
      groupType = 'WithElements';
      break;
  }

  return _objectSpread(_objectSpread({}, g), {}, {
    type: 'UserClassifierGroupNode',
    groupType: groupType
  });
}
export function toApiGroupNode(g) {
  var type;

  var groupType = g.groupType,
      others = _objectWithoutProperties(g, _excluded);

  switch (g.groupType) {
    case 'Empty':
      type = 'UserClassifierEmptyGroupNode';
      break;

    case 'WithGroups':
      type = 'UserClassifierGroupWithGroupsNode';
      break;

    case 'WithElements':
      type = 'UserClassifierGroupWithElementsNode';
      break;
  }

  return _objectSpread(_objectSpread({}, others), {}, {
    type: type
  });
}
export function buildKeyByPath(path) {
  return path.join(':');
}
export var getClassifierInfo = function getClassifierInfo(_node, getParentRef) {
  var node = _node.type === 'LoadMore' ? _node.parentNode : _node;

  if (node.type === 'ReferenceNode') {
    return {
      sourceClassifierId: node.parentClassifierId,
      sourceClassifierVersion: node.parentClassifierVersion
    };
  } else if (node.type === 'UserClassifierGroupNode' || isUserClassifierGroupNode(node)) {
    return {
      sourceClassifierId: node.parentClassifierId,
      sourceClassifierVersion: node.parentClassifierVersion
    };
  } else if (isUserClassifierNode(node) || isAssemblyClassifierNode(node) || node.type === 'AnonymousClassifierNode') {
    return {
      sourceClassifierId: node.id,
      sourceClassifierVersion: node.version
    };
  } else if (isBimNode(node)) {
    var ref = getParentRef();

    if (ref) {
      return {
        sourceClassifierId: ref.parentClassifierId,
        sourceClassifierVersion: ref.parentClassifierVersion
      };
    }
  } else if (node.type === 'DynamicGeneratedGroupNode') {
    return {
      sourceClassifierId: node.parentClassifierId,
      sourceClassifierVersion: node.parentClassifierVersion
    };
  }

  throw new Error("[getClassifierInfo]: \u043D\u0435 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0430\u043D\u043D\u044B\u0439 \u0441\u043B\u0443\u0447\u0430\u0439 ".concat(node.type));
};